import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App'
import { installGlobalErrorHandlers } from './lib/clientErrorReporter'
import { i18nReady } from './features/i18n'

// 전역 JS/Promise 에러를 백엔드로 보고(관리자 에러 모니터링)
installGlobalErrorHandlers()

// PWA 서비스워커 — 홈 화면 설치 + 현장 오프라인 진입(캐시 전략은 public/sw.js 참조).
// prerender(headless)에서도 등록되지만 결과 HTML 에는 영향이 없다(부작용 없음).
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* 설치 실패해도 앱은 정상 동작 */ })
  })
}

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root 엘리먼트를 찾을 수 없습니다')

// 번역 리소스(ko/en)는 dynamic import 청크다 — 감지된 언어 번들이 준비된 뒤 렌더한다.
// 이렇게 하면 문구가 빈 채로 깜빡이는 FOUC 가 원천적으로 없고, prerender(puppeteer) 도
// 항상 번역이 채워진 HTML 을 얻는다.
// 로드 실패(네트워크 등) 시에도 앱은 반드시 뜬다 — 흰 화면 방지.
i18nReady
  .catch(() => { /* 번역 로드 실패해도 앱 렌더는 진행 */ })
  .then(() => {
    createRoot(rootEl).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  })
